import React from "react";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompressArrowsAlt, faExpandArrowsAlt, faExclamationTriangle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Button, Icon } from "aible";
import { isEnabled } from "utils/featureFlags";
import { useDispatch, useSelector } from "types/store";
import { LIST_VIEW_COLUMNS } from "types/sense";
import { getIsExpanded, getIsLoadingChat, getIsLoadingCreateAI, getIsLoadingExplore, getListColumnCount, getListDataQuality, getListDataReadiness, getListDataSource, getListDatasetName, getListDatasetOwner, getListDateCreated, getListInsights, getListOutcomeLabel, getListPredictorCount, getListProblematicPredictors, getListRowCount, getOutcome, getOutcomeSuccess } from "containers/Sense/dataset-selectors";
import { getIsPinned, updateIsPinned, updateTileState } from "containers/Sense/reducer";
import { openCreateModels, openExploration } from "containers/Next/NextReducer";
import { getIsTableauMode } from "containers/App/reducer";
import { deleteDataset, getDataset, getOutcomeOptions, setDatasetTarget } from "containers/Home/reducer";
import LeakageChartContainer from "containers/Next/Charts/LeakageChart";
import Tooltip from "components/Inputs/Tooltip";
import SenseTile from "components/Tiles/Sense/SenseTile";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import PinnedDarkIcon from "images/Sense-Icons/pinned.svg";
import UnpinnedDarkIcon from "images/SenseIcons/thumbtack-dark.svg";
import TrashPurpleIcon from "images/SenseIcons/trash-purple.svg";
import styles from "./../style.module.css";
import { handleSelectUseCase } from "containers/ChatGPT/reducer";
import { mapToSelectOption } from "@/utils/select";
const DatasetListItem = ({ datasetId, history }) => {
    const dispatch = useDispatch();
    const isPinned = useSelector((state) => getIsPinned(state, datasetId));
    const dataset = useSelector((state) => getDataset(state, datasetId));
    const isTableauMode = useSelector((state) => getIsTableauMode(state));
    const updateIsLoadingExplore = (isLoadingExplore) => {
        dispatch(updateTileState(datasetId, { isLoadingExplore }));
    };
    const updateIsLoadingCreateAI = (isLoadingCreateAI) => {
        dispatch(updateTileState(datasetId, { isLoadingCreateAI }));
    };
    const isExpanded = useSelector((state) => getIsExpanded(state, datasetId));
    const retDatasetName = useSelector((state) => getListDatasetName(state, datasetId));
    const retRowCount = useSelector((state) => getListRowCount(state, datasetId));
    const retColumnCount = useSelector((state) => getListColumnCount(state, datasetId));
    const predictorCount = useSelector((state) => getListPredictorCount(state, datasetId));
    const dateCreated = useSelector((state) => getListDateCreated(state, datasetId));
    const retOwnerName = useSelector((state) => getListDatasetOwner(state, datasetId));
    const outcomeValue = useSelector((state) => getOutcomeSuccess(state, datasetId));
    const { datasetTypeLabel, datasetIconGray } = useSelector((state) => getListDataSource(state, datasetId));
    const dataQuality = useSelector((state) => getListDataQuality(state, datasetId));
    const retOutcomeLabel = useSelector((state) => getListOutcomeLabel(state, datasetId));
    const dataReadiness = useSelector((state) => getListDataReadiness(state, datasetId));
    const { hasProblematicPredictors, problematicPredictorCount } = useSelector((state) => getListProblematicPredictors(state, datasetId));
    const insightCount = useSelector((state) => getListInsights(state, datasetId));
    const isLoadingChat = useSelector((state) => getIsLoadingChat(state, datasetId));
    const isLoadingExplore = useSelector((state) => getIsLoadingExplore(state, datasetId));
    const isLoadingCreateAI = useSelector((state) => getIsLoadingCreateAI(state, datasetId));
    const isError = dataset?.dataset_status === "ERROR";
    const isProcessing = dataset?.status_name !== "DONE" && !isError;
    const hasOutcome = Boolean(dataset.outcome);
    const options = useSelector((state) => getOutcomeOptions(state, dataset.id));
    const outcome = useSelector((state) => getOutcome(state, datasetId));
    return (React.createElement(React.Fragment, { key: datasetId },
        React.createElement("tr", { style: { padding: "5px 10px", borderBottom: "1px solid #8e8e9c" } },
            React.createElement("td", { style: { padding: "5px 10px" } },
                React.createElement("div", { className: styles.senseCell },
                    React.createElement(Button, { onClick: (e) => {
                            e.stopPropagation();
                            dispatch(updateIsPinned(datasetId, !isPinned));
                        }, style: { padding: "6px" }, active: isPinned, type: "transparent" },
                        React.createElement("img", { src: isPinned ? PinnedDarkIcon : UnpinnedDarkIcon, style: {
                                height: "13px",
                                width: "13px"
                            } })))),
            React.createElement("td", { style: { padding: "5px 10px" } },
                React.createElement("div", { className: styles.senseCell },
                    React.createElement("div", { className: styles.senseListDatasetSource },
                        React.createElement("img", { src: datasetIconGray, alt: datasetTypeLabel })),
                    React.createElement(Tooltip, { trigger: ["hover"], overlay: datasetTypeLabel },
                        React.createElement("div", { className: styles.senseListName }, datasetTypeLabel)))),
            React.createElement("td", { style: { padding: "5px 10px" } },
                React.createElement("div", { className: styles.senseCell },
                    React.createElement(Tooltip, { trigger: ["hover"], overlay: retDatasetName },
                        React.createElement("a", { className: styles.senseListName, style: { maxWidth: "150px" }, onClick: () => {
                                if (isTableauMode) {
                                    return console.log("dclick", datasetId);
                                }
                                if (isEnabled("aible-optimize")) {
                                    return history.push("/next/" + dataset?.id + "/new");
                                }
                                if (isEnabled("aible-explore")) {
                                    updateIsLoadingExplore(true);
                                    setTimeout(() => dispatch(openExploration(dataset?.id, outcomeValue, undefined))
                                        .catch((e) => console.log(e))
                                        .finally(() => updateIsLoadingExplore(false)), 5);
                                }
                            } }, retDatasetName)))),
            React.createElement("td", { style: { padding: "5px 10px" } },
                React.createElement("div", { className: styles.senseCell },
                    React.createElement("div", { style: { marginRight: dataQuality.showBadge ? "8px" : undefined } }, dataQuality.dataQualityLabel),
                    dataQuality.showBadge && (React.createElement("div", { className: styles.sIcon, style: {
                            color: isError ? "rgb(248, 205, 126)" : undefined,
                            marginRight: "0px"
                        } },
                        React.createElement(FontAwesomeIcon, { icon: isError ? faExclamationTriangle : faCheckCircle }))))),
            React.createElement("td", { style: { padding: "5px 10px" } },
                React.createElement("div", { className: styles.senseCell + " " + styles.listOutcome }, hasOutcome ? (React.createElement(Tooltip, { trigger: ["hover"], overlay: retOutcomeLabel },
                    React.createElement("div", { className: styles.senseListName }, retOutcomeLabel))) : isProcessing ? (React.createElement(LoadingIndicator, { style: {
                        margin: "0px",
                        transform: "scale(0.5)",
                        position: "absolute"
                    } })) : isError ? (React.createElement("div", null, "\u00A0")) : (React.createElement("div", { className: styles.listOutcomeSelect },
                    React.createElement(Select, { options: options, onChange: (val) => {
                            if (val && "value" in val) {
                                dispatch(updateTileState(datasetId, {
                                    outcome: {
                                        isLoadingRetarget: true,
                                        datasetOutcome: val.value,
                                        outcomeSuccess: undefined
                                    }
                                }));
                            }
                        }, menuPlacement: "top", value: mapToSelectOption(outcome.datasetOutcome) }))))),
            React.createElement("td", { style: { padding: "5px 10px" } }, isError ? (React.createElement("div", { className: styles.senseCell, style: { minWidth: "50px" } }, "ERROR")) : isProcessing && hasOutcome ? (React.createElement("div", { className: styles.senseCell, style: { minWidth: "50px" } },
                React.createElement(LoadingIndicator, { style: {
                        margin: "0px",
                        transform: "scale(0.5)",
                        position: "absolute"
                    } }))) : (React.createElement("div", { className: styles.senseCell },
                React.createElement("div", { style: {
                        marginRight: dataReadiness.showBadge ? "8px" : undefined
                    } }, dataReadiness.dataReadinessLabel),
                dataReadiness.showBadge && (React.createElement("div", { className: styles.sIcon, style: {
                        color: dataReadiness.isWarning ? "rgb(248, 205, 126)" : undefined,
                        marginRight: "0px"
                    } },
                    React.createElement(FontAwesomeIcon, { icon: dataReadiness.isWarning ? faExclamationTriangle : faCheckCircle })))))),
            React.createElement("td", { style: { padding: "5px 10px" } }, predictorCount),
            React.createElement("td", { style: { padding: "5px 10px" } },
                React.createElement("div", { className: styles.senseCell },
                    React.createElement("div", { style: {
                            marginRight: problematicPredictorCount !== undefined ? "8px" : undefined
                        } }, problematicPredictorCount),
                    problematicPredictorCount !== undefined &&
                        (hasProblematicPredictors ? (React.createElement(Icon, { type: "warning", size: 14 })) : (React.createElement("div", { className: styles.sIcon, style: { marginRight: "0px" } },
                            React.createElement(FontAwesomeIcon, { icon: faCheckCircle })))))),
            React.createElement("td", { style: { padding: "5px 10px" } },
                React.createElement("div", { className: styles.senseCell },
                    React.createElement("div", { className: styles.senseListMuscleChartWrapper },
                        React.createElement("div", { className: styles.senseListMuscleChart },
                            React.createElement(LeakageChartContainer, { id: "new", datasetId: dataset?.id, height: 120, width: 120, innerRadius: 14, isTiny: true, hideChords: true }))),
                    React.createElement("div", { className: styles.senseListName, style: { marginLeft: "4px" } }, insightCount))),
            React.createElement("td", { style: { padding: "5px 10px" } }, retRowCount),
            React.createElement("td", { style: { padding: "5px 10px" } }, retColumnCount),
            React.createElement("td", { style: { padding: "5px 10px" } }, dateCreated),
            React.createElement("td", { style: { padding: "5px 10px" } },
                React.createElement("div", { className: styles.senseCell },
                    React.createElement(Tooltip, { trigger: ["hover"], overlay: retOwnerName },
                        React.createElement("div", { className: styles.senseListName }, retOwnerName)))),
            React.createElement("td", { onClick: (event) => event.stopPropagation() }, isProcessing ? (React.createElement("div", { className: styles.senseCell, style: { minWidth: "50px" } },
                React.createElement(LoadingIndicator, { style: {
                        margin: "0px",
                        transform: "scale(0.5)",
                        position: "absolute"
                    } }))) : isError ? (React.createElement("div", { className: styles.senseCell, style: { minWidth: "50px" } })) : !dataset?.outcome ? (React.createElement("div", { className: styles.senseCell },
                React.createElement(Button, { onClick: () => outcome.datasetOutcome && dispatch(setDatasetTarget(dataset?.id, outcome.datasetOutcome)), disabled: outcome.datasetOutcome === undefined, type: "primary" }, "Evaluate Data Readiness"))) : (React.createElement("div", { className: styles.senseCell },
                isEnabled("chat-aible") && (React.createElement(Button, { onClick: () => {
                        dispatch(handleSelectUseCase("CHATAIBLE_ANALYTICS", datasetId));
                    }, style: {
                        minWidth: "unset",
                        padding: "9px 14px",
                        marginRight: "8px",
                        position: "relative"
                    }, isLoading: isLoadingChat === true }, "Agentic Analytics Chat")),
                (isEnabled("aible-optimize") || isEnabled("aible-explore")) && (React.createElement(Button, { onClick: () => {
                        updateIsLoadingExplore(true);
                        setTimeout(() => dispatch(openExploration(dataset?.id, outcomeValue, undefined))
                            .catch((e) => console.log(e))
                            .finally(() => updateIsLoadingExplore(false)), 5);
                    }, style: {
                        minWidth: "unset",
                        padding: "9px 14px",
                        marginRight: "8px",
                        position: "relative"
                    } }, isLoadingExplore === true ? (React.createElement(LoadingIndicator, { style: {
                        margin: "0px",
                        transform: "scale(0.5)",
                        position: "absolute"
                    } })) : ("Explore"))),
                isEnabled("aible-optimize") && (React.createElement(Button, { onClick: () => {
                        updateIsLoadingCreateAI(true);
                        setTimeout(() => {
                            dispatch(openCreateModels(dataset?.id, outcomeValue, undefined))
                                .catch((e) => console.log(e))
                                .finally(() => updateIsLoadingCreateAI(false));
                        }, 5);
                    }, style: {
                        minWidth: "unset",
                        padding: "9px 14px",
                        marginRight: "8px",
                        position: "relative"
                    } }, isLoadingCreateAI === true ? (React.createElement(LoadingIndicator, { style: {
                        margin: "0px",
                        transform: "scale(0.5)",
                        position: "absolute"
                    } })) : ("Create AI"))),
                React.createElement(Button, { onClick: (e) => {
                        e.stopPropagation();
                        dispatch(deleteDataset(dataset?.id));
                    }, style: { padding: "9px" } },
                    React.createElement("img", { className: styles.pinImage, src: TrashPurpleIcon }))))),
            React.createElement("td", { style: { padding: "5px 10px" } },
                React.createElement(Button, { onClick: () => {
                        dispatch(updateTileState(datasetId, { isExpanded: !isExpanded }));
                    }, style: { padding: "9px" } },
                    React.createElement("div", { className: styles.listExpandIcon },
                        React.createElement(FontAwesomeIcon, { icon: isExpanded ? faCompressArrowsAlt : faExpandArrowsAlt }))))),
        isExpanded && (React.createElement("tr", null,
            React.createElement("td", { colSpan: LIST_VIEW_COLUMNS.length },
                React.createElement("div", { className: styles.listExpandedView },
                    React.createElement(SenseTile, { id: datasetId })))))));
};
export default withRouter(DatasetListItem);
